module.exports = __webpack_public_path__ + "img/biei_hoheykyo2.b7853a56.png";